import { CashierManagementComponent } from './components/cashier-management/cashier-management.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: 'management', component: CashierManagementComponent },
    { path: 'management:ContextSelected', component: CashierManagementComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CashierRoutingModule {}
